document.addEventListener('alpine:init', () => {
  Alpine.data('ThemeModule_CartFooter', () => {
    return {
      footerRoot: null,
      itemsRoot: null,
      upsellInitialized: false,

      setShippingCountry(shippingCountryvalue) {
        localStorage.setItem('ELKAD-userShippingCountry', shippingCountryvalue);
      },

      getShippingCountry() {
        return localStorage.getItem('ELKAD-userShippingCountry');
      },

      async _morphFooter(e) {
        if (e.detail.response.sections) {
          const self = this;
          const newFooterSection = querySelectorInHTMLString(
            '[data-cart-footer]',
            e.detail.response.sections['cart-footer']
          );

          Alpine.morph(
            this.footerRoot,
            newFooterSection ? newFooterSection.outerHTML : '',
            {
              updating(el, toEl, childrenOnly, skip) {
                if (
                  el.classList &&
                  el.classList.contains('additional-checkout-buttons')
                ) {
                  skip();
                }
              },
              added(el) {
                // Initialiser seulement les boutons nouvellement ajoutés
                if (el.classList && (el.hasAttribute('data-checkout-button') || el.querySelector('[data-checkout-button]'))) {
                  self.initCheckoutButton();
                }

                if (el.classList && (el.id =='user-shipping-country' || el.querySelector('#user-shipping-country'))) {
                  self.initShippingCountry();
                }

                if (el.classList && (el.classList.contains('elkad-cart-product-upsell__right__button') || el.querySelector('.elkad-cart-product-upsell__right__button'))) {
                  self.initCartUpsellProduct();
                }
              }
            }
          );

          if (e.detail.response.sections['cart-items']) {
            Alpine.morph(
              this.itemsRoot,
              querySelectorInHTMLString(
                '[data-cart-items]',
                e.detail.response.sections['cart-items']
              ).outerHTML
            );
          }
        }
      },

      initShippingCountry() {
        const selectShippingCountry = document.querySelector("#user-shipping-country");

        if (!selectShippingCountry) return;
        
        const localStorageShippingCountry = this.getShippingCountry();
        selectShippingCountry.value = localStorageShippingCountry != null ? localStorageShippingCountry : Shopify.country;

        if (selectShippingCountry.value == "") {
          const cartItemsThatNeedShipping = window.liquidAjaxCart.cart.items.filter((item) => item.requires_shipping);

          const updates = {"updates": {}};

          cartItemsThatNeedShipping.forEach((item) => {
            updates["updates"][`${item.id}`] = 0
          });

          if (Object.keys(updates["updates"]).length > 0) {
            window.liquidAjaxCart.update(updates);
          }
        }

        selectShippingCountry.addEventListener('change', async () => {
          const selectedCountry = selectShippingCountry.value;
          this.setShippingCountry(selectedCountry);

          await window.liquidAjaxCart.update({});
        });
      },

      initCheckoutButton() {
        const checkoutButton = document.querySelector('[data-cart-footer] [data-checkout-button]');

        if (!checkoutButton) return;

        checkoutButton.parentElement.addEventListener('click', async (event) => {
          // Empêcher la propagation de l'événement au cas où
          event.stopPropagation();
          
          checkoutButton.classList.add("elkad-js-button--loading")
          await window.liquidAjaxCart.update({}, {lastCallback: () => {
            window.location.href = checkoutButton.getAttribute("data-checkout-href");
          }});
        });
      },

      async initUpgradeButtons() {
        const upgradeCart = async () => {
          const upgradeButton = document.querySelector('.elkad-upgrade-cart');
          if(upgradeButton) {
            upgradeButton.classList.add('elkad-upgrade-cart-anim');
          }

          const cartData = window.liquidAjaxCart.cart;
          let items = cartData.items;
    
          const oneTimeProductIndex = items.findIndex((item) => (item.product_id == 8872545026340));
          const subscriptionProductIndex = items.findIndex((item) => (item.variant_id == 47696075260196));

          const globalCallback = () => {
            upgradeButton.classList.remove('elkad-upgrade-cart-anim');
          }
    
          if (oneTimeProductIndex > -1) {            
            const callback = () => {
              if (subscriptionProductIndex < 0) {
                window.liquidAjaxCart.add({
                  'id': '47696075260196',
                  'selling_plan': 689705451812,
                  'quantity': items[oneTimeProductIndex].quantity,
                  'properties': {
                    'Note': window.ELKAD.shipsInApril
                  }
                });
              }
            }
    
            window.liquidAjaxCart.change({
              'id': '' + items[oneTimeProductIndex].id + '',
              'quantity': 0
            }, {firstCallback: () => callback(), lastCallback: () => globalCallback()});
          }
    
          if (subscriptionProductIndex > -1) {
            window.liquidAjaxCart.change({
              'id': '47696075260196',
              'selling_plan': 689705451812,
              'properties': {
                'Note': window.ELKAD.shipsInApril
              }
            }, {lastCallback: () => globalCallback()});
          } 
        }
        
        const allUpgradeButtons = document.querySelectorAll('.elkad-upgrade-cart');
        
        allUpgradeButtons.forEach((button) => {
          button.addEventListener('click', upgradeCart);
        });
      },

      async initRecipeClubButtons() {
        const addToCart = async (button) => {
          const add_to_cart_data = JSON.parse(button.getAttribute('data-add-to-cart-button'));
          const product_id = button.getAttribute('data-product-id');
          const cartData = window.liquidAjaxCart.cart;
          let items = cartData.items;

          if (product_id) {
            const recipeClubProductIndex = items.findIndex((item) => (item.product_id == product_id));

            if (recipeClubProductIndex == -1) {
              window.liquidAjaxCart.add(add_to_cart_data);
            } else {
              Alpine.store('modals').open('cart');
            }
          } else {
            window.liquidAjaxCart.add(add_to_cart_data);
          }
        };

        const add_to_cart_buttons = document.querySelectorAll('[data-add-to-cart-button]');

        add_to_cart_buttons.forEach((button) => {
          button.addEventListener('click', () => {
            addToCart(button)
          });
        });
      },
      
      async initCartUpsellProduct() {
        // Créer une fonction pour la gestion du bouton d'ajout au panier dans l'encadré de l'upsell du panier
        const cartProductUpsell = document.querySelector('.elkad-cart-product-upsell');

        if (!cartProductUpsell) return;

        const cartProductUpsellButton = cartProductUpsell.querySelector('.elkad-cart-product-upsell__right__button');

        cartProductUpsellButton.addEventListener('click', (event) => {
          // Empêcher la propagation de l'événement
          event.preventDefault();
          event.stopPropagation();
          
          cartProductUpsellButton.classList.add('elkad-js-button--loading');

          const data = {
            quantity: 1,
            id: cartProductUpsell.getAttribute('data-variant-id')
          }

          const sellingPlanId = cartProductUpsell.getAttribute('data-selling-plan-id');

          if (sellingPlanId) {
            data['selling_plan'] = sellingPlanId;
          }

          const autoAddPillbox = cartProductUpsell.getAttribute('data-auto-add-pillbox');

          if (autoAddPillbox) {
            data['properties'] = {
              '_auto_add_pillbox': true
            };
          }

          window.liquidAjaxCart.add(data);
        });
      },

      async init() {
        window.addEventListener('pageshow', (event) => {
          if (event.persisted) {
            const checkoutButton = document.querySelector('[data-cart-footer] [data-checkout-button]');
            checkoutButton.classList.remove("elkad-js-button--loading")
          }
        });
      
        this.initCheckoutButton();
        this.initShippingCountry();

        this.footerRoot = this.$root;
        this.itemsRoot = document.querySelector('[data-cart-items]');

        this.initUpgradeButtons();
        this.initRecipeClubButtons();
        this.initCartUpsellProduct();
      }
    };
  });
});